/*eslint-disable */
/**
 * @copyright    Copyright © 2025-2026 GIDE.AI
 * @author       Alok Pabalkar  <alok@gide.ai>
 * @package      Gide
 * @license      Proprietary
 * @description  Utility functions that calculate the score obtained in mocks of GIDEPrep
 *
 */

import TestSeriesConfig from "../FackApi/json/TestSeries.json"

/**
 * New Calculation is based on a SAT Score Lookup table provided by College Board
 * https://satsuite.collegeboard.org/media/pdf/scoring-sat-practice-test-4-digital.pdf
 *
 * Sample Calculator
 * https://www.learnq.ai/digital-sat-score-calculator
 * https://www.albert.io/blog/sat-score-calculator/
 * https://blog.prepscholar.com/how-to-calculate-sat-score
 * https://www.edisonos.com/digital-sat/calculate-digital-sat-score
 *
 * Based on the correct answer ~ raw score get the scaled score using the lookup
 */
function satModuleScoreCalculation (key, chainAppFinal, context) {
  let oldMethod = 0
  if (oldMethod == 1) {
    chainAppFinal.correct_answer_module1 = chainAppFinal.correct_answer_module1 == 0 ? chainAppFinal.correct_answer_total : chainAppFinal.correct_answer_module1 // For cases where module wise correct answers are not sent from the server, consider total correct answers for calculating the score. This is to avoid breaking the score calculation in such cases. This is specifically for older attempts of users where module wise correct answers were not stored in the database and hence not sent from the server
    // Use the SAT Lookup chart to find the category Score
    if (key.includes("English") || key.includes("Eng")) {
      chainAppFinal.app_score = chainAppFinal.correct_answer_module1 > 13 ? TestSeriesConfig.rwUpperScoreTable[chainAppFinal.correct_answer_total - 1] : TestSeriesConfig.rwLowerScoreTable[chainAppFinal.correct_answer_total - 1]
    }
    else if (key.includes("Math")) {
      chainAppFinal.app_score = chainAppFinal.correct_answer_module1 > 11 ? TestSeriesConfig.mathUpperScoreTable[chainAppFinal.correct_answer_total - 1] : TestSeriesConfig.mathLowerScoreTable[chainAppFinal.correct_answer_total - 1]
    }
  }
  else {
    // Save the Score of Modules
    chainAppFinal.app_score = (chainAppFinal.app_score_module1 || 0) + (chainAppFinal.app_score_module2 || 0)
    // console.log(key, "XXXXXX---11", chainAppFinal)
  }

  return Math.round(chainAppFinal.app_score / 10) * 10
}

/**
 * Build the Answer Counts using the chained Apps Data
 * To be used for SAT Score Calculation
 *
 */
function satScoreCalculation (chainApp = null, context) {
  if (!chainApp) {
    return
  }

  let correctAnswer = chainApp.correct_answer
  if (chainApp.app_name.includes(context.appNameWithTHON)) {
    correctAnswer = chainApp.correct_answer * 2 // For Satathon double it
  }

  let oldMethod = 0
  if (oldMethod == 1) {
    if (chainApp.app_name.includes("Math")){
      chainApp.app_score = 200 + (600 / 44) * correctAnswer
      chainApp.app_score = Math.round(chainApp.app_score / 10) * 10

      if (context.SAT_FINAL_CHAIN_LIST["Maths"].app_score == 0) {
        context.SAT_FINAL_CHAIN_LIST["Maths"].app_score = chainApp.app_score
      }
      else {
        context.SAT_FINAL_CHAIN_LIST["Maths"].app_score = (context.SAT_FINAL_CHAIN_LIST["Maths"].app_score + chainApp.app_score) / 2
      }

      context.SAT_FINAL_CHAIN_LIST["Maths"].app_score = Math.round(context.SAT_FINAL_CHAIN_LIST["Maths"].app_score / 10) * 10
    }
    else if (chainApp.app_name.includes("English") || chainApp.app_name.includes("Eng")) {
      chainApp.app_score = 200 + (600 / 54) * correctAnswer * 2
      chainApp.app_score = Math.round(chainApp.app_score / 10) * 10

      if (context.SAT_FINAL_CHAIN_LIST["English"].app_score == 0) {
        context.SAT_FINAL_CHAIN_LIST["English"].app_score = chainApp.app_score
      }
      else {
        context.SAT_FINAL_CHAIN_LIST["English"].app_score = (context.SAT_FINAL_CHAIN_LIST["English"].app_score + chainApp.app_score) / 2
      }
      context.SAT_FINAL_CHAIN_LIST["English"].app_score = Math.round(context.SAT_FINAL_CHAIN_LIST["English"].app_score / 10) * 10
    }
  }
  else {
    if (chainApp.app_name.includes("Math")) {
      // Save the Score of Module 1
      if (chainApp.app_name.includes("Module-1")) {
        context.SAT_FINAL_CHAIN_LIST["Maths"].correct_answer_module1 = correctAnswer
        chainApp.app_score = TestSeriesConfig.satMath1ScoreTable[correctAnswer]
        context.SAT_FINAL_CHAIN_LIST["Maths"].app_score_module1 = chainApp.app_score
      }
      else {
        context.SAT_FINAL_CHAIN_LIST["Maths"].correct_answer_module2 = correctAnswer
        chainApp.app_score = TestSeriesConfig.satMath2ScoreTable[correctAnswer]
        context.SAT_FINAL_CHAIN_LIST["Maths"].app_score_module2 = chainApp.app_score
      }

      // chainApp.app_score = context.SAT_FINAL_CHAIN_LIST["Maths"].correct_answer_module1 > 11 ? TestSeriesConfig.mathUpperScoreTable[correctAnswer] : TestSeriesConfig.mathLowerScoreTable[correctAnswer]

      context.SAT_FINAL_CHAIN_LIST["Maths"].correct_answer_total += correctAnswer
    }
    else if (chainApp.app_name.includes("English") || chainApp.app_name.includes("Eng")) {
      // Save the Score of Module 1
      if (chainApp.app_name.includes("Module-1")) {
        context.SAT_FINAL_CHAIN_LIST["English"].correct_answer_module1 = correctAnswer
        chainApp.app_score = TestSeriesConfig.satEng1ScoreTable[correctAnswer]
        context.SAT_FINAL_CHAIN_LIST["English"].app_score_module1 = chainApp.app_score
      }
      else {
        context.SAT_FINAL_CHAIN_LIST["English"].correct_answer_module2 = correctAnswer
        chainApp.app_score = TestSeriesConfig.satEng2ScoreTable[correctAnswer]
        context.SAT_FINAL_CHAIN_LIST["English"].app_score_module2 = chainApp.app_score
      }

      // chainApp.app_score = context.SAT_FINAL_CHAIN_LIST["English"].correct_answer_module1 > 13 ? TestSeriesConfig.rwUpperScoreTable[correctAnswer] : TestSeriesConfig.rwLowerScoreTable[correctAnswer]
      context.SAT_FINAL_CHAIN_LIST["English"].correct_answer_total += correctAnswer
    }
  }

  // console.log(context.SAT_FINAL_CHAIN_LIST, correctAnswer, "XXXXXX-000000", chainApp.app_score)
}

/**
 * psat8And9ScoreCalculation
 *
 * New Calculation is based on a SAT Score Lookup table provided by College Board
 * https://satsuite.collegeboard.org/media/pdf/scoring-sat-practice-test-4-digital.pdf
 *
 * Sample Calculator
 * https://www.learnq.ai/digital-sat-score-calculator
 * https://www.albert.io/blog/sat-score-calculator/
 * https://blog.prepscholar.com/how-to-calculate-sat-score
 * https://www.edisonos.com/digital-sat/calculate-digital-sat-score
 *
 * Based on the correct answer ~ raw score get the scaled score using the lookup
 * NB: This function only uses a different upper/lower bound tables rest is same as "satScoreCalculation"
 */
function psat8And9ScoreCalculation (key, chainAppFinal, context) {
  chainAppFinal.correct_answer_module1 = chainAppFinal.correct_answer_module1 == 0 ? chainAppFinal.correct_answer_total : chainAppFinal.correct_answer_module1 // For cases where module wise correct answers are not sent from the server, consider total correct answers for calculating the score. This is to avoid breaking the score calculation in such cases. This is specifically for older attempts of users where module wise correct answers were not stored in the database and hence not sent from the server
  // Use the SAT Lookup chart to find the category Score
  if (key.includes("English") || key.includes("Eng")) {
    chainAppFinal.app_score = chainAppFinal.correct_answer_module1 > 13 ? TestSeriesConfig.psat8And9RwUpperScoreTable[chainAppFinal.correct_answer_total] : TestSeriesConfig.psat8And9RwLowerScoreTable[chainAppFinal.correct_answer_total]
  }
  else if (key.includes("Math")) {
    chainAppFinal.app_score = chainAppFinal.correct_answer_module1 > 11 ? TestSeriesConfig.psat8And9MathUpperScoreTable[chainAppFinal.correct_answer_total] : TestSeriesConfig.psat8And9MathLowerScoreTable[chainAppFinal.correct_answer_total]
  }

  return Math.round(chainAppFinal.app_score / 10) * 10
}

/**
 * The CLAT (Common Law Admission Test) marking scheme involves awarding 1 mark for each correct answer
 * and deducting 0.25 marks for each incorrect answer
 */
function clatScoreCalculation (chainApp = null, context) {
  if (!chainApp) {
    return
  }

  chainApp.app_score = chainApp.correct_answer - (0.25 * chainApp.wrong_answer)
  chainApp.categoryScoreRangeMin = `(${0 - (0.25 * chainApp.qbk_total_question)})`
  chainApp.categoryScoreRangeMax = chainApp.qbk_total_question
  return chainApp.app_score
}

/**
 * The CUET marking scheme involves awarding 5 mark for each correct answer
 * and deducting 1 mark for each incorrect answer and 0 marks for unanswered questions.
 */
function cuetScoreCalculation (chainApp = null, context) {
  if (!chainApp) {
    return
  }

  chainApp.app_score = chainApp.correct_answer * 5 - (1 * chainApp.wrong_answer)
  chainApp.categoryScoreRangeMin = `(${0 - (1 * chainApp.qbk_total_question)})`
  chainApp.categoryScoreRangeMax = chainApp.qbk_total_question * 5
  return chainApp.app_score
}

/**
 * apCalculateWeightedScore
 */
function apCalculateWeightedScore (chainApp = null, apWt) {
  if (!chainApp) {
    return
  }

  const scoreObj = {}
  scoreObj.mcq_score = (chainApp.score_obtained_mcq / chainApp.total_score_mcq) * apWt.mcq_wt
  scoreObj.frq_score = (chainApp.score_obtained_frq / chainApp.total_score_frq) * apWt.frq_wt

  scoreObj.mcq_score = isNaN(scoreObj.mcq_score) ? 0 : scoreObj.mcq_score
  scoreObj.frq_score = isNaN(scoreObj.frq_score) ? 0 : scoreObj.frq_score

  return scoreObj
}

/**
 * apCalculateCompositeScore
 */
function apCalculateCompositeScore (scoreObj, apWt) {
  // Weighted average (composite score)
  let rawApScore = (
    scoreObj.mcq_score +
    scoreObj.frq_score
  ) * 100
  rawApScore = isNaN(rawApScore) ? 0 : rawApScore

  if (rawApScore <= 0) {
    return 0 // Take the composite score as 0
  }

  let compositeScore = 0;
  for (let apScore of Object.keys(apWt.ap_score_table)) {
    if (rawApScore >= Number(apScore)) {
      compositeScore = apWt.ap_score_table[apScore]
    }
  }

  return compositeScore
}

/**
 * apScoreCalculation
 */
function apScoreCalculation (quizResDetailsChainArr, context) {
  const apWt = getApWt(quizResDetailsChainArr[0].app_category)

  const scoreObj = {
    mcq_score: 0,
    frq_score: 0,

    score_obtained_mcq: 0,
    total_score_mcq: 0,

    score_obtained_frq: 0,
    total_score_frq: 0
  }

  quizResDetailsChainArr.map((chainedApp) => {
    let scoreForQuiz = apCalculateWeightedScore(chainedApp, apWt)

    scoreObj.mcq_score += scoreForQuiz.mcq_score
    scoreObj.frq_score += scoreForQuiz.frq_score

    scoreObj.score_obtained_mcq += chainedApp.score_obtained_mcq
    scoreObj.total_score_mcq += chainedApp.total_score_mcq

    scoreObj.score_obtained_frq += chainedApp.score_obtained_frq
    scoreObj.total_score_frq += chainedApp.total_score_frq

  })

  scoreObj.mcq_stats = `${scoreObj.score_obtained_mcq} / ${scoreObj.total_score_mcq}`
  scoreObj.frq_stats = `${scoreObj.score_obtained_frq} / ${scoreObj.total_score_frq}`

  scoreObj.combined_score_obtained = scoreObj.score_obtained_mcq + scoreObj.score_obtained_frq
  scoreObj.combined_total_score = scoreObj.total_score_mcq + scoreObj.total_score_frq

  scoreObj.ap_score = apCalculateCompositeScore(scoreObj, apWt)

  return scoreObj
}

/**
 * getApWt
 */
function getApWt (appCategory) {
  if (appCategory.toLowerCase().includes("bio")) {
    return TestSeriesConfig.ap_bio
  }
  else if (appCategory.toLowerCase().includes("chemistry")) {
    return TestSeriesConfig.ap_chem
  }
  else if (appCategory.toLowerCase().includes("psychology")) {
    return TestSeriesConfig.ap_psycho
  }
  else if (appCategory.toLowerCase().includes("calculus")) {
    return TestSeriesConfig.ap_calc_bc
  }
  else if (appCategory.toLowerCase().includes("evs")) {
    return TestSeriesConfig.ap_evs
  }
  else if (appCategory.toLowerCase().includes("stat")) {
    return TestSeriesConfig.ap_stat
  }
  else if (appCategory.toLowerCase().includes("macroeconomics")) {
    return TestSeriesConfig.ap_macroeconomics
  }
  else if (appCategory.toLowerCase().includes("microeconomics")) {
    return TestSeriesConfig.ap_microeconomics
  }
}

export {
  satModuleScoreCalculation,
  satScoreCalculation,
  psat8And9ScoreCalculation,
  clatScoreCalculation,
  cuetScoreCalculation,
  apScoreCalculation,
}
